module.exports = __webpack_public_path__ + "static/media/announcement_bar_app_1 copy.7e45af48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/announcement_bar_app_1 copy.png
// module id = 394
// module chunks = 0